{
  "title": "Panou de extragere",
  "subtitle": "Fiecare rulare de extragere: rezultatul fiecărui site și anunțurile găsite.",
  "back": "Toate rulările",
  "status": {
    "completed": "Finalizată",
    "partial": "Parțială",
    "failed": "Eșuată",
    "running": "În curs",
    "success": "Succes",
    "blocked": "Blocat",
    "pending": "În așteptare",
    "not_run": "Nerulat"
  },
  "scrapers": {
    "immobilier_ch": "Immobilier.ch",
    "homegate_ch": "Homegate.ch",
    "comparis_immobilier": "Comparis",
    "properstar_ch": "Properstar.ch",
    "anibis_ch": "Anibis.ch",
    "immoscout24_ch": "ImmoScout24.ch",
    "newhome_ch": "Newhome.ch"
  },
  "trigger": {
    "scheduled": "Programată",
    "manual": "Manuală"
  },
  "singleScraper": "Un singur site: {{name}}",
  "singleScraperBanner": "În această rulare a fost executat doar {{name}}; celelalte site-uri nu au fost rulate.",
  "noBreakdown": "Nu există detalii pentru această rulare",
  "list": {
    "filters": {
      "status": "Stare",
      "scraper": "Site",
      "scope": "Domeniu",
      "all": "Toate",
      "fullRuns": "Toate site-urile",
      "singleRuns": "Un singur site"
    },
    "empty": "Nicio rulare de extragere deocamdată",
    "columns": {
      "run": "Rulare",
      "started": "Început",
      "status": "Stare",
      "scrapers": "Site-uri",
      "site": "Pe site",
      "parsed": "Citite",
      "filtered": "Filtrate",
      "imported": "Importate",
      "updated": "Actualizate",
      "unchanged": "Neschimbate",
      "merged": "Îmbinate",
      "duration": "Durată"
    }
  },
  "detail": {
    "title": "Rularea #{{id}}",
    "started": "Început: {{date}}",
    "invalidRun": "Identificator de rulare invalid",
    "viewRunLog": "Jurnalele rulării",
    "runError": "Eroarea rulării",
    "legacy": "Această rulare este anterioară detaliilor pe site: sunt disponibile doar totalurile."
  },
  "summary": {
    "siteReported": "Pe site",
    "parsed": "Citite",
    "dropped": "Eliminate",
    "filteredOut": "Filtrate",
    "imported": "Importate",
    "updated": "Actualizate",
    "unchanged": "Neschimbate",
    "merged": "Îmbinate",
    "failed": "Eșuate",
    "duration": "Timp total"
  },
  "breakdown": {
    "title": "Site-uri",
    "viewLog": "Jurnale",
    "columns": {
      "scraper": "Site",
      "status": "Stare",
      "site": "Pe site",
      "parsed": "Citite",
      "dropped": "Eliminate",
      "filtered": "Filtrate",
      "returned": "Returnate",
      "imported": "Importate",
      "updated": "Actualizate",
      "unchanged": "Neschimbate",
      "merged": "Îmbinate",
      "retired": "Retrase",
      "failed": "Eșuate",
      "duration": "Durată",
      "perAd": "Pe anunț",
      "error": "Eroare"
    }
  },
  "ads": {
    "title": "Anunțuri",
    "scraper": "Site",
    "allScrapers": "Toate site-urile",
    "outcomes": {
      "imported": "Importate",
      "updated": "Actualizate",
      "unchanged": "Neschimbate",
      "merged": "Îmbinate",
      "filtered_out": "Filtrate",
      "dropped": "Eliminate",
      "failed": "Eșuate"
    },
    "columns": {
      "title": "Anunț",
      "scraper": "Site",
      "price": "Preț",
      "rooms": "Camere",
      "size": "Suprafață",
      "details": "Detalii",
      "time": "Timp",
      "links": "Linkuri"
    },
    "untitled": "Anunț fără titlu",
    "empty": "Niciun anunț în această categorie",
    "openInApp": "Deschide în aplicație",
    "openOnSite": "Deschide pe site",
    "mergedInto": "Îmbinat cu anunțul #{{id}}",
    "viewLog": "Jurnale",
    "timeTooltip": "Pagina de detalii {{scrape}}, import {{import}}"
  },
  "logs": {
    "runTitle": "Jurnalele rulării #{{id}}",
    "scraperTitle": "Rularea #{{id}}: jurnalele {{name}}",
    "itemTitle": "Rularea #{{id}}: jurnalele anunțului"
  }
}
